import Container from '@ui/shared/components/Container'

export default function GPTDetector() {
  return (
    <Container className='py-3 md:py-10 flex flex-col gap-4'>
      <p>
        AI-generated text is now almost indistinguishable from human writing. New models produce
        more varied and complex text, with better fine-tuning through prompts. This makes it harder
        to tell whether a text was written by AI or a human. Research by OpenAI and other third
        parties, as well as our own analysis, has shown that AI detection tools have high error
        rates. They often misidentify human-written text as AI-generated and vice versa.
      </p>
      <p>
        <a
          className='underline'
          href='https://help.openai.com/en/articles/8313351-how-can-educators-respond-to-students-presenting-ai-generated-content-as-their-own'
          target='_blank'
          rel='noreferrer'
        >
          OpenAI also found that
        </a>{' '}
        students who speak English as a second language or use a more formulaic or concise writing
        style are more likely to be incorrectly flagged as using AI. All AI detectors face the same
        challenge. As AI improves, detection methods become less accurate, making them unreliable
        for assessing academic integrity. Because of this, we’ve decided to take our GPT Detector
        offline. Academic integrity is important to us, and we don’t want to offer a tool that no
        longer works as intended.
      </p>
      <p>
        If you have any questions, feel free to reach out at{' '}
        <a className='underline' href='mailto:support@writefull.com'>
          support@writefull.com
        </a>
        .<br />
        Thanks for your support!
      </p>
    </Container>
  )
}
